module.exports = __webpack_public_path__ + "img/ISTJ.74ef3a9c.png";